(function ($) {
	$(document).gp_ready(function () {
		$('[data-quantity-action]').off().gp_on('click', function () {
			let action = $(this).data('quantity-action'),
				$input = $(this).siblings('input[type="number"]'),
				current_qty = parseInt($input.val());
			if (action == 'plus') {
				let max = $input.attr("max") ? parseInt($input.attr("max")) : 0
				if (!max || current_qty < max) {
					$input.val(current_qty + 1).trigger('change input');
				}
			} else if (action == 'minus') {
				let min = $input.attr("min") ? parseInt($input.attr("min")) : 0
				if (!min || current_qty > min) {
					$input.val(current_qty - 1).trigger('change input');
				}
			}
		})
	})
})(jQuery);
